import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { Box, Tooltip, Collapse, Typography } from '@mui/material';

import { apiList, getCancelData } from '../../api/callAPI';

import useUser from '../../hook/useUser';
import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';

import { MODAL_SEND_LIST } from '../modal/constants';

import * as urlConstants from '../../constants/url';
import * as alertConstants from '../../constants/alertMsg';
import * as mediaConstants from '../../constants/mediaData';

import { ContentCopyIcon } from '../../constants/images';

const CopyReport = (props) => {
  const {
    media,
    row,
    setIsLoadingData,
    setModalName,
    fetchData,
    setPage
  } = props;

  const intl = useIntl();
  const history = useHistory();
  const { currentActiveData, setCurrentActiveData, setModalContent, isModalOpen, setIsModalOpen, modalContent, modalData, setModalData } = useGlobalStatus();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const handleBiweeklyStart = () => {
    const currentDate = row.biweekly_start;
    let biweeklyStart;

    if (currentDate !== null) {
      const getMonth = currentDate.monthValue > 9 ? currentDate.monthValue : `0${currentDate.monthValue}`;
      const getDay = currentDate.dayOfMonth > 9 ? currentDate.dayOfMonth : `0${currentDate.dayOfMonth}`;
      biweeklyStart = `${currentDate.year}-${getMonth}-${getDay}`
    } else {
      biweeklyStart = null;
    }

    return biweeklyStart;
  }

  const accouontIds = row.facebookAccounts.map(el => el.adAccountId);

  const updatedFields = row.fields.map(({ sheet, ...edition }) => ({
    ...edition,
    sheet: sheet !== null ? sheet : [],
  }));

  const handleCopyReport = (row) => {
    const { weeklyReportName, biweekly_start, facebookAdAccountIds, fields, ...rest } = row;

    const createReportData = {
      ...rest,
      weeklyReportName: `${row.weeklyReportName} - ${intl.formatMessage({ id: "common.button.copy", defaultMessage: "copy" })}`,
      biweekly_start: handleBiweeklyStart(),
      facebookAdAccountIds: accouontIds,
      fields: updatedFields,
    }
    fetchCreateReport(createReportData, weeklyReportName);
  }

  const fetchCreateReport = (createReportData, weeklyReportName) => {
    setModalName('');
    setIsLoadingData(true);

    const result = apiList[mediaConstants.MEDIA_DATA[media].api.createReport](createReportData);

    result.then(res => {
      if (res.status === 200) {
        setIsLoadingData(false);
        setModalData({ weeklyReportName: weeklyReportName });
        setModalContent({ ...MODAL_SEND_LIST['completeCopy'], media: media });
        setIsModalOpen(true);

        setTimeout(() => {
          setIsModalOpen(false);
          fetchData();
          setPage(0);
        }, 2000)

      } else if (res.status === 500 || res.status === 400) {
        setModalContent({ ...MODAL_SEND_LIST['failedCopy'], media: media });
        setIsModalOpen(true);
        setIsLoadingData(false);

        setTimeout(() => {
          setIsModalOpen(false);
        }, 1000)
      } else {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      }
    })
  }

  return (
    <Tooltip title={<FormattedMessage id="sendList.copyReport.copyReport" />} placement="bottom">
      <ContentCopyIcon
        variant="dark"
        sx={{
          cursor: 'pointer',
          '&:hover': { color: mainColor }
        }}
        onClick={() => {
          handleCopyReport(row);
          setCurrentActiveData(row);
        }}
      />
    </Tooltip>
  )
}

export default CopyReport;